import React from 'react'
import CommonPayment from './CommonPayment';
import { PROD } from '../../common/constants';

function AdvancePayment() {

  return (
    <div>
      {!PROD && <p style={{ textAlign: "right", fontSize: "2vh" }}>PAY01</p>}
      <CommonPayment paymentType="Advance" />
    </div>

  )
}

export default AdvancePayment;